interface Props {
  text: string
}
const CaseLabel = ({ text }: Props) => {
  return <label className='text-sm font-bold'>{text}</label>
}

export default CaseLabel
